import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sections: [
      {
        "id": 0,
        "title": "Affärsmässighet",
        "shorttitle": "Affärsmässighet",
        "entry": "En offentlig inköpare behöver kunskap och fallenhet att balansera behov och krav, och att baserat på dem utforma upphandlingsunderlag som leder till goda affärer för båda parter.",
        "resultentry": "Inom området affärsmässighet anser SOI att inköparens erfarenhet i kombination med intresse väger tungt för att kunna balansera ibland motstridiga behov och krav, och baserat på dem utforma upphandlingsunderlag som leder till goda affärer för båda parter.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver ha ett affärsmässigt synsätt, det vill säga kunna balansera behov och krav, och baserat på dem utforma upphandlingsunderlag.\n\n" + "Som inköpare krävs förmågan att hantera olika målkonflikter till exempel mellan pris och kvalitet.\n\n" + "Även andra aspekter som den aktuella marknadsförutsättningar, omvärldsläget och dess förväntade utveckling under avtalsperioden behöver hanteras.\n\n" + "Uppgiften är att göra en så bra affär som möjligt givet behoven, möjligheterna samt de förutsättningar som ges av regelverk och av den aktuella affärssituationen.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 20
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 50
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 30
        }]
      },
      {
        "id": 1,
        "title": "Marknads- och omvärldsanalys",
        "shorttitle": "Marknadsbev.",
        "entry": "En offentlig inköpare behöver förmågan att kunna analysera och bedöma marknad och omvärld och baserat på det utforma affären på ett bättre sätt.",
        "resultentry": "Inom området marknads- och omvärldsanalys anser SOI att inköparens erfarenhet i kombination med intresse väger tungt för att kunna analysera marknad, omvärld och samhällsutveckling och baserat på det utforma affären på ett bättre sätt.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver förmåga att utföra marknads- och omvärldsanalyser. Marknadsanalys är en relativt generisk kompetens, där erfarenhet från en bransch kan räcka långt även för en annan.\n\n" + "En bra omvärldsanalys stödjer marknadsanalysen, och syftar till att ge information om hur branschen kan påverkas och förändras i framtiden, i synnerhet under den förväntade avtalstiden.\n\n" + "Genom att kunna analysera den marknad som står till buds för det aktuella behovet kan inköparen utforma affären på ett bättre sätt.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 20
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 50
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 30
        }]
      },
      {
        "id": 2,
        "title": "Strategiutveckling",
        "shorttitle": "Strategiutv.",
        "entry": "En offentlig inköpare behöver förmågan att utforma en bra strategi för att nå den önskade affären.",
        "resultentry": "Inom området strategi anser SOI att inköparens erfarenhet väger tungt för att kunna utforma en välgrundad strategi som leder till en bra och affärsmässig helhetslösning.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver förmågan att utforma strategier utifrån organisationens affärsmål. Intresse och fallenhet för analysarbete är av vikt för att kunna utforma en bra strategi, då den ska grunda sig i bland annat behovsanalyser, marknads- och omvärldsanalyser samt identifiering av eventuella målkonflikter.\n\n" + "Det behövs även kunskaper inom upphandlingslagstiftning och andra relevanta regelverk, så att regelverken kan nyttjas för att göra de mest framgångsrika valen.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 30
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 40
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 30
        }]
      },
      {
        "id": 3,
        "title": "Förhandling",
        "shorttitle": "Förhandling",
        "entry": "En offentlig inköpare behöver ha kompetens inom förhandling, förhandlingsprincipen, förhandlingsteknik och taktik.",
        "resultentry": "Inom området förhandling anser SOI att inköparens erfarenhet av affärsförhandling väger tungt. Utbildning i förhandling och förhandlingsteknik är en bra förutsättning som förädlas med erfarenhet.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver ha kompetens och intresse för att ta tillvara möjligheter till förhandling. Den dialog som behövs i alla beskrivna förfaranden, och i all kommunikation med leverantörer förutsätter god förhandlingskompetens.\n\n" + "Till exempel att under ett avtals löptid kunna förhandla med leverantören om avtalstolkning, avvikelser, kompensationer eller sanktioner.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 25
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 50
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 25
        }]
      },
      {
        "id": 4,
        "title": "Juridik",
        "shorttitle": "Juridik",
        "entry": "Juridik är en självklar grund för framgångsrikt inköpsarbete. En offentlig inköpare behöver också förmågan att väga juridiska aspekter mot ansvaret för, och möjligheten till, goda affärer för samhället.",
        "resultentry": "Inom området juridik anser SOI att inköparens utbildning i kombination av erfarenhet av i första handavtalsrätt och offentlig upphandling väger tungt för att kunna väga juridiska aspekter mot ansvaret för, och möjligheten till, goda affärer för samhället.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver ha god kunskap inom Avtalsrätt och Upphandlingslagstiftning. Avtalsrätt är grunden i ett affärsmässigt förhållningssätt.\n\n" + "Utformningen av avtal samt förmågan att bedöma hur de kan tillämpas, av bägge parter, under giltighetstid är en viktig del av den totala affärsmässigheten. Upphandlingslagstiftningen är självklara grunder som en inköpare måste kunna väl.\n\n" + "Även andra juridiska områden som exempelvis offentlighet- och sekretesslagstiftning, förvaltningsrätt, bolagsrätt, processrätt och konkurrensrätt är en fördel att ha kunskap inom.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 50
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 30
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 20
        }]
      },
      {
        "id": 5,
        "title": "Projektledning",
        "shorttitle": "Projektledning",
        "entry": "En offentlig inköpare behöver i många fall kunskap och förmåga att kunna planera, leda och driva projekt.",
        "resultentry": "Inom området projektledning anser SOI att inköparens erfarenhet i kombination av utbildning väger tungt för att kunna planera, leda och driva framgångsrika projekt som leder till goda affärer.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver i många fall kunna planera, leda och driva projekt.\n\n" + "Då krävs förmågan att kunna analysera behov, definiera vad projektgruppen ska åstadkomma, planera aktiviteter och milstolpar, klara ut rollfördelning samt att driva och följa upp de aktiviteter som tillsammans ska leda fram till att projektmålen nås.\n\n" + "Därmed ta ett större ansvar för att den bästa affären ska uppnås.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 30
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 50
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 20
        }]
      },
      {
        "id": 6,
        "title": "Kravställning",
        "shorttitle": "Kravställning",
        "entry": "En offentlig inköpare behöver förmågan att ställa och formulera rätt krav baserat på organisationens behov.",
        "resultentry": "Inom området kravställning anser SOI att inköparens erfarenhet i kombination av utbildning väger tungt för att kunna ställa och formulera rätt krav baserat på behov.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver förmågan att formulera tydliga krav som med rätt nivå beskriver de olika aspekterna av krav på upphandlingsföremålet.\n\n" + "Genom arbete med kravhantering ska en inköpare kunna analysera och identifiera verksamhetsbehov och affärsnytta från en övergripande nivå ner till tydliga kravspecifikationer, inklusive bedömning av hur krav ska kontrolleras och uppfyllas.\n\n" + "För att på ett systematiskt sätt kunna specificera verksamhetens behov och också ha rätt nivå i kravställningen behöver en inköpare därför kompetens inom kravhantering.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 30
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 50
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 20
        }]
      },
      {
        "id": 7,
        "title": "Sak- och omvärldskunskap",
        "shorttitle": "Sakkunskap",
        "entry": "En offentlig inköpare behöver förmågan att snabbt och lätt sätta sig in i olika sakområden för att förenkla och effektivisera processen.",
        "resultentry": "Inom området kravställning anser SOI att inköparens intresse för området väger tungt. Marknader utvecklas snabbt och genom att följa dem blir vi bättre på att utnyttja nya möjligheter för att nå affärsmål.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare bör ha fallenhet för att snabbt sätta sig in i sakområdet en upphandling gäller för att på bästa vis förenkla och effektivisera processen.\n\n" + "Kunskaper om miljömässig-, social- och ekonomisk hållbarhet behövs då många offentliga organisationer har ambitioner att använda sina inköp till att bidra till samhällsförbättringar på dessa områden.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 30
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 30
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 40
        }]
      },
      {
        "id": 8,
        "title": "Ekonomi och kalkylering",
        "shorttitle": "Ekonomi",
        "entry": "En offentlig inköpare behöver kunskap om ekonomiska principer och förmågan att genomföra grundläggande finansiella analyser.",
        "resultentry": "Inom området ekonomi och kalkylering anser SOI att inköparens utbildning i kombination med erfarenhet väger tungt för att kunna genomföra goda affärer enligt ekonomiska principer och baserade på finansiella analyser.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver kunna tolka och dra slutsatser om företags och organisationers finansiella ställning genom att tolka extern redovisning, förstå budgeteringen, nyckeltal och möjligheter samt begränsningar vid kalkylering.\n\n" + "En behöver även kunskaper för att kunna analysera förhållandet mellan värde och kostnader för skilda lösningar på problem behövs, också för att utvärdera leverantörernas situation.\n\n" + "Även kunskaper inom olika typer av investeringskalkyler. Exempelvis ekonomiska kostnader i livscykeln (LCC) eller miljöpåverkan (LCA) och sambandet mellan verksamhetsmål och lämplig investeringskalkyl.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 50
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 30
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 20
        }]
      },
      {
        "id": 9,
        "title": "Analys",
        "shorttitle": "Analys",
        "entry": "En offentlig inköpare behöver ha intresse och fallenhet för olika typer av analysarbete.",
        "resultentry": "Inom området analys anser SOI att inköparens erfarenhet väger tungt för att kunna väga samman information av olika typ som påverkar hur en upphandling bör utformas och genomföras.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare bör ha förmågan att väga samman information av olika typ som påverkar hur en upphandling bör utformas och genomföras.\n\n" + "Vid bland annat förarbete, utformning av strategi och utvärdering av inkomna anbud krävs en analytisk förmågas.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 30
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 40
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 30
        }]
      },
      {
        "id": 10,
        "title": "Kommunikation",
        "shorttitle": "Kommunikation",
        "entry": "En offentlig inköpare behöver ha förmågan att kommunicera väl både i tal och skrift.",
        "resultentry": "Inom området kommunikation anser SOI att inköparens erfarenhet i kombination med intresse väger tungt för att i både i tal och skrift kommunicera tydligt, bland annat i idéstadiet, i argumentationer och i framtagningen av upphandlingsunderlaget.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpares kommunikativa förmåga i både tal och skrift är viktigt.\n\n" + "Muntlig kommunikation behövs för att bland annat presentera tankar och idéer effektivt, och för att argumentera för de affärsmässiga och regelmässiga aspekterna ska få rätt viktning i förhållande till de behovsorienterade.\n\n" + "Dessutom är muntlig förmåga givetvis viktig i en förhandlingssituation. God kommunikativ förmåga i skrift behövs för en inköpare när upphandlingsunderlag och annan dokumentation ska tas fram, men även för att kunna presentera bra och tydliga projektplaner i förberedelseskedet.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 20
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 40
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 40
        }]
      },
      {
        "id": 11,
        "title": "Ledarskap och förändringsledning",
        "shorttitle": "Ledarskap",
        "entry": "En offentlig inköpare behöver i vissa fall, för mer utvecklade inköpsroller, kunskaper inom ledarskap och förändringsledning.",
        "resultentry": "Inom området ledarskap- och förändringsledning anser SOI att inköparens erfarenhet väger tungt för att ge affärsfrågorna rätt fokus, utveckla inköp till ett strategiskt verktyg och bidra till att nå verksamhetens mål.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver kunskaper inom ledarskap och förändringsledning.\n\n" + "God ledarskapskompetens inom inköpsorganisationen kan hjälpa till att ge affärsfrågorna rätt fokus inom organisationen, och att utveckla inköp till ett strategiskt verktyg för att bidra till verksamhetens mål.\n\n" + "I en organisation som har nått hög mognad inom det kategoristyrda arbetssättet innebär kategoriledarrollen i mycket stor utsträckning även förändringsledning.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 25
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 50
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 25
        }]
      },
      {
        "id": 12,
        "title": "Digitalisering",
        "shorttitle": "Digitalisering",
        "entry": "En offentlig inköpare behöver kunskaper inom och erfarenhet av digitala verktyg och IT-system, men också ett intresse för vad digitaliseringen kan ge för mervärden i samhället.",
        "resultentry": "Inom området digitalisering anser SOI att inköparens intresse väger tungt för att se digitaliseringens möjligheter. Digitalisering är verksamhetsutveckling där nya tekniska möjligheter bör tas tillvara på för att skapa lösningar som möter verksamheternas och medborgarnas behov idag och över tid.",
        "text": "Bedöm din kompetens inom området!",
        "djupning": "En offentlig inköpare behöver kunskap inom och erfarenhet av grundläggande digitala verktyg.\n\n" + "Att behärska de vanliga verktygen för modernt kontorsarbete väl (ordbehandling, kalkylarbete projektsamarbete etc.) är också en förutsättning för allt inköpsarbete.\n\n" + "För strategiskt inköpsarbete behövs en högre grad av digital mognad och intresse för området, samt förmågan att kunna se digitaliseringens möjligheter. Bland annat för att genomföra analyser av datamängder, ta fram information som underlag för strategiska vägval och kravställa IT-utveckling för att skapa nya analysmetoder inom organisationen.",
        "questions": [{
          "text": "Utbildning",
          "entry": "Din utbildningsnivå kan vara allt ifrån ingen alls till gymnasiekompetens, enstaka kurser på högskola/universitet eller annan relevant utbildningsinstans till examen från högskola/universitet.",
          "id": 0,
          "point": 30
        },
        {
          "text": "Erfarenhet",
          "entry": "Här ska du bedöma din erfarenhet. Från att du inte arbetat med området alls, till att ha viss erfarenhet (1-5 år) eller omfattande erfarenhet (6 år eller mer) inom området.",
          "id": 1,
          "point": 30
        },
        {
          "text": "Intresse",
          "entry": "Här ska du bedöma hur mycket du tilltalas av arbetsuppgifter inom området och hur intresserad du är av att veta och lära dig mer om området inom ramen för ditt arbete eller på din fritid.",
          "id": 2,
          "point": 40
        }]
      }
    ],
    answers: {}
  },
  mutations: {
    initStore (state) {
      if (localStorage.getItem("result")) {
        state.answers = JSON.parse(localStorage.getItem("result"));
      }
    },
    updateAnswer (state, payload) {
      if (state.answers[payload.sectionId] === undefined) {
        state.answers[payload.sectionId] = {};
      }
      if (state.answers[payload.sectionId][payload.questionId]) {
        state.answers[payload.sectionId][payload.questionId].answer = payload.answer;
        state.answers[payload.sectionId][payload.questionId].sliderValue = payload.sliderValue;
      } else {
        state.answers[payload.sectionId][payload.questionId] = {
          answer: payload.answer,
          sliderValue: payload.sliderValue
        };
      }
      localStorage.setItem("result", JSON.stringify(state.answers));
    }
  },
  actions: {
    updateAnswer ({
      commit
    }, payload) {
      commit("updateAnswer", payload);
    }
  }
});
